/*

--------------------------------------------------------------------------------
Oriflame-made radio button widget using some Kendo-style functionality.
--------------------------------------------------------------------------------

<![CDATA[

*/

; (function ($) {

    "use strict";

    var kendo = window.kendo,
        ui = kendo.ui,
        Widget = ui.Widget,
        getCulture = kendo.getCulture,
        CHANGE = "change",
        DISABLED = "disabled",
        INPUT = "k-input",
        RADIO = "input:radio",
        ns = ".kendoRadioButton",
        MOUSELEAVE = "mouseleave" + ns,
        HOVEREVENTS = "mouseenter" + ns + " " + MOUSELEAVE,
        DEFAULT = "k-state-default",
        FOCUSED = "k-state-focused",
        HOVER = "k-state-hover",
        SELECTED = "k-state-selected",
        STATEDISABLED = "k-state-disabled",
        STATEREADONLY = "k-state-readonly",
        AVATAR = "avatar",
        RADIO_LIST_ITEM_CLASS = "w-radio-item",
        proxy = $.proxy,
        NESTED_RADIO_LIST = '.js-nested-radio-list',
        NO_SHADOW = 'no-shadow',
        DATA_ACTIVE_HIDDEN = '[data-active-hidden]',
        DATA_ACTIVE_SHOWN = '[data-active-shown]';

    var RadioButton = Widget.extend({

        sel: {
            SELECTED_ITEM: "selected",
            RADIO_LIST_ITEM_SELECTOR: "." + RADIO_LIST_ITEM_CLASS
        },

        init: function (element, options) {
            var self = this;
            Widget.fn.init.call(self, element, options);
            element = self.element
                .addClass(INPUT)
                .on("click" + ns, proxy(self._click, self))
                .on("blur" + ns, proxy(self._focusout, self))
                .attr("role", "radio");
            options = self.options;
            // remember title text - needed for various description UI types
            options.titleText = options.titleText || element.attr("title");
            element.removeAttr("title");
            if (self.options.readonly === undefined)
                self.options.readonly = element.hasClass(STATEREADONLY);
            self._reset();
            self._wrapper();
            Widget.fn.descriptionUi.call(self);
            kendo.moveCustomStylesToWrapper.call(self);
            if (!kendo.support.mobileOS) element.on("focus" + ns, proxy(self._focusin, self));
            self._old = self.defaultValue();
            self.value(self.defaultValue());
            self.enable(!element.is('[disabled]'));
            kendo.notify(self);
        },

        options: kendo.getUpdatedWidgetOptions({
            name: "RadioButton",
            value: null,
            culture: ""
        }),

        events: [CHANGE],

        /**
		 * Enables / disables the whole widget.
		 */
        enable: function (enable) {
            var self = this;
            self.options.disable = !enable;
            if (enable) { self.options.readonly = false; }
            radioButtonEditable(self, self.options);
        },

        readonly: function (readonly) {
            var self = this;
            self.options.readonly = readonly;
            radioButtonEditable(self, self.options);
        },

        value: function (value) {
            var self = this;
            if (typeof value == "undefined") return self._value;
            self._update(value);
            self._old = self._value;
        },

        /**
		 * Returns the default value of the widget as set in init().
		 * Value specified in JS options has precedence over value in markup.
		 */
        defaultValue: function () {
            var self = this,
                value = self.options.value;

            if (value !== null) {
                return value;
            }

            var markupValue = self.element.is(':checked');
            return markupValue;
        },

        focus: function () {
            this._focusin();
        },

        /**
		 * Creates a HTML wrapper around the generated widget.
		 * For now we use a hidden control with false value trick, so that a value
		 * is always sent to server for every radio. So we have to find nearest
		 * hidden input and include it also in the generated wrapper.
		 */
        _wrapper: function () {
            var self = this,
                $element = self.element,
                DOMelement = $element[0],
                id = $element.attr("id"),
                $wrapper = $element.parent(),
                $hidden = $wrapper.find('input[type="hidden"]'),
                $labels = $wrapper.find('label[for="' + id + '"].widget-label');
            $element.removeClass(AVATAR);
            if (!$wrapper.is("span.k-widget")) {
                $wrapper = $element.wrap("<span />").parent();
                if ($hidden.length) $hidden.detach().insertAfter($element);
                if ($labels.length) $labels.detach().appendTo($wrapper);;
            }
            // radio list
            if ($wrapper.find(".js-radio-list").length > 0) {
                $wrapper.parent().wrapInner('<div class="' + RADIO_LIST_ITEM_CLASS + '" />');
            }
            // aria
            $wrapper
                .attr("tabindex", "-1")
                .attr("role", "presentation");
            // end
            $wrapper[0].style.cssText = DOMelement.style.cssText;
            self.wrapper = $wrapper
                .addClass("k-widget k-radio")
                .addClass(DOMelement.className)
                .removeClass("k-input");
            self._addIconElement();
        },

        _addIconElement: function () {
            var self = this,
                $wrapper = self.wrapper;
            $wrapper.prepend("<span class='k-icon radio-icon'></span>");
            $wrapper.find(RADIO).addClass("invisible");
        },

        _toggleHover: function (event) {
            $(event.currentTarget).toggleClass(HOVER, event.type === "mouseenter");
        },

        _click: function (event) {
            var self = this,
                $input = self._findItemInput(event.target);
            self.info(self.describeEvent(event, "_click"));

            if (!$input) return;
            self._change(true);

            clearTimeout(self._focusing);
            self._focusing = setTimeout(function () { self._focusin(); });
        },

        _findItemInput: function (element) {
            var self = this,
                $element = $(element);
            if (!$element[0]) return null;
            if ($element.is(RADIO)) return $element;

            var attrName = $element.attr('name'),
                $found = $(RADIO + '[name="' + attrName + '"]');
            return $found;
        },

        _findItemWithValue: function (value) {
            var self = this,
                attrName = self.element.attr('name'),
                $items = $(RADIO + '[name="' + attrName + '"]');
            $result;
            $items.each(function () {
                var $this = $(this);
                if ($this.val() === value) {
                    $result = $this;
                    return false;
                }
            });
            return $result;
        },

        _change: function (value) {
            var self = this;
            if (self.options.readonly) { return; }
            self._update(value);
            value = self._value;
            if (self._old != value) {
                self._old = value;

                // trigger the DOM change event so any subscriber gets notified
                /* If we don't stop original (click) event from bubbling everyone gets notified anyway.
                   If we attempt to stop it and trigger it manually afterwards most browsers will trigger it twice :/. */
                //self.element.trigger( CHANGE );

                self.trigger(CHANGE);
            }
        },

        /**
		 * Due to some incompatibilities between browsers we set the value using
		 * input.checked property. We don't manipulate with the checked attribute
		 * to protect the original value for optional form reset.
		 * TODO : verify that this works
		 */
        _update: function (value) {
            var self = this;
            self._value = value;
            if (value) {
                self._deselectAll();
                self.element.prop("checked", value);
                self._select();
            }
        },

        _culture: function (culture) {
            return culture || getCulture(this.options.culture);
        },

        _focus: function (event) {
            var self = this;
            self.info(
                "_focus - type : %s,\n\ttarget : %s,\n\tcurrent target : %s",
                event.type,
                self.describeElement(event.target),
                self.describeElement(event.currentTarget)
            );
            clearTimeout(self._focusing);
            self._focusing = setTimeout(function () { self._focusin(); });
        },

        _focusin: function () {
            var self = this;
            self.wrapper.addClass(FOCUSED);
            self.element[0].focus();
        },

        _focusout: function (event) {
            var self = this;
            self.info(
                "_focusout - type : %s,\n\ttarget : %s,\n\tcurrent target : %s",
                event.type,
                self.describeElement(event.target),
                self.describeElement(event.currentTarget)
            );
            clearTimeout(self._focusing);
            self.wrapper.removeClass(FOCUSED);
        },

        _select: function () {
            var self = this,
                $nestedList = self.wrapper.parents(NESTED_RADIO_LIST),
                $dataShown = self.wrapper.siblings(DATA_ACTIVE_SHOWN),
                $dataHidden = self.wrapper.siblings(DATA_ACTIVE_HIDDEN);

            // Nested radio list - on second click on an item the item is closed / unchecked.
            if ($nestedList.length && self.wrapper.hasClass(SELECTED)) {
                self._deselect(self);
                $nestedList.parents(self.sel.RADIO_LIST_ITEM_SELECTOR).removeClass(NO_SHADOW);
                return;
            }

            // Return if the selected item is alrady selected
            if (self.wrapper.hasClass(SELECTED)) {
                return;
            }

            self.wrapper.parent(self.sel.RADIO_LIST_ITEM_SELECTOR).addClass(self.sel.SELECTED_ITEM);
            // if the selected item is within nested list then we remove the shadow on the parent list item
            $nestedList.length && $nestedList.parents(self.sel.RADIO_LIST_ITEM_SELECTOR).addClass(NO_SHADOW);

            // Keep the actions below in this order so we can perform the slideDown and slideUp animations
            // the display block below is needed because when we add class SELECTED to the wrapper the $dataHidden element becomes display none, and there is no slideUp
            $dataHidden.length && $dataHidden.css('display', 'block').slideUp();
            $dataShown.length && $dataShown.slideDown();
            self.wrapper.addClass(SELECTED);
        },

        _deselect: function (radio) {
            if (radio) {
                var $dataShown = radio.wrapper.siblings(DATA_ACTIVE_SHOWN),
                    $dataHidden = radio.wrapper.siblings(DATA_ACTIVE_HIDDEN);

                radio.wrapper.parent(radio.sel.RADIO_LIST_ITEM_SELECTOR).removeClass(radio.sel.SELECTED_ITEM);
                radio._old = false;
                radio._value = false;
                $dataHidden.length && $dataHidden.slideDown();
                $dataShown.length && $dataShown.slideUp();
                radio.wrapper.removeClass(SELECTED);
            }
        },

        _deselectAll: function () {
            var self = this,
                attrName = self.element.attr('name'),
                $other = $(RADIO + '[name="' + attrName + '"]').not(self.element);
            $other
                .prop("checked", false)
                .each(function () {
                    self._deselect($(this).data('kendoRadioButton'));
                });
        },

        _reset: function () {
            var self = this,
                $element = self.element,
                $form = $element.closest("form");
            if ($form[0]) {
                self._resetHandler = function () {
                    setTimeout(function () {
                        self.value(self.defaultValue());
                    });
                };
                self._form = $form.on("reset", self._resetHandler);
            }
        }

    });

    function radioButtonEditable(that, options) {
        var self = that,
            $element = self.element,
            $wrapper = self.wrapper.off(HOVEREVENTS),
            readonly = options.readonly,
            disable = options.disable;
        if (!readonly && !disable) {
            $wrapper
                .addClass(DEFAULT)
                .removeClass(STATEDISABLED)
                .removeClass(STATEREADONLY)
                .on(HOVEREVENTS, self._toggleHover);
            $element
                .prop(DISABLED, false);
        } else {
            if (readonly) {
                $wrapper.addClass(STATEREADONLY).removeClass(DEFAULT).removeClass(STATEDISABLED).on(HOVEREVENTS, self._toggleHover);
            }
            if (disable) {
                $wrapper.addClass(STATEDISABLED).removeClass(DEFAULT).removeClass(STATEREADONLY);
            }
            $element.prop(DISABLED, disable);
        }
    }

    ui.plugin(RadioButton);

})(window.kendo.jQuery);

/* ]]> */